import { FC, useState } from 'react';
import { useCreateUserNoteMutation } from '@teachur/http-client';
import { Button } from '@new/common/ui/Button/Button';
import { Textarea } from '@new/common/ui/Textarea/Textarea';

interface AddNoteFormProps {
  objectiveId: number;
}

export const AddNoteForm: FC<AddNoteFormProps> = ({ objectiveId }) => {
  const [noteText, setNoteText] = useState('');
  const { mutate: createNote, isPending: isCreating } = useCreateUserNoteMutation({
    onSuccess: () => setNoteText(''),
  });

  const onSubmit = () => {
    if (!noteText.trim()) return;
    createNote({ note: noteText, objective: objectiveId });
  };

  return (
    <div className="flex flex-1 flex-col gap-2 pt-4">
      <h4 className="[font-family:var(--font-arvo)]! [font-size:var(--fs-l3)]! text-(--neutral-black-NB1000)! font-semibold! m-0!">
        Add note
      </h4>
      <Textarea value={noteText} onChange={setNoteText} rows={3} placeholder="Write your note..." />
      <Button
        variant="primary"
        size="sm"
        onClick={onSubmit}
        disabled={isCreating || !noteText.trim()}
        className="self-end"
        text="Save note"
      />
    </div>
  );
};
